import { useTranslation } from 'react-i18next'
import { useAuth } from '../hooks/useAuth'
import { appName } from '../main'
import styles from './WelcomePage.module.css'

export default function WelcomePage() {
  const { t } = useTranslation()
  const { signIn, register } = useAuth()

  return (
    <div className={styles.page}>
      <h1 className={styles.title} dir="auto">{appName}</h1>
      <img
        src="/logo.jpg"
        alt={appName}
        className={styles.logo}
      />
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.loginBtn}
          onClick={signIn}
        >
          {t('welcome_log_in')}
        </button>
        <button
          type="button"
          className={styles.registerBtn}
          onClick={register}
        >
          {t('welcome_sign_up')}
        </button>
      </div>
    </div>
  )
}
